"use client";

import { VisualEditing } from "@sanity/visual-editing/react";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

export function VisualEditingWrapper() {
  const [mounted, setMounted] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setMounted(true);

    // Log when component mounts for debugging
    console.log("VisualEditing component mounted");

    return () => {
      console.log("VisualEditing component unmounted");
    };
  }, []);

  // Prevent hydration mismatch by only rendering on client
  if (!mounted) {
    return null;
  }

  return (
    <VisualEditing
      portal={true}
      zIndex={999999}
      history={{
        subscribe: (navigate) => {
          const handlePopState = () => {
            navigate({
              type: "push",
              url: window.location.href,
            });
          };

          window.addEventListener("popstate", handlePopState);
          return () => window.removeEventListener("popstate", handlePopState);
        },
        update: (update) => {
          console.log("History update:", update);
          switch (update.type) {
            case "push":
              router.push(update.url);
              break;
            case "replace":
              router.replace(update.url);
              break;
            case "pop":
              router.back();
              break;
          }
        },
      }}
      refresh={(payload) => {
        console.log("Refresh requested:", payload);
        if (payload.source === "mutation") {
          // Force a refresh when content is updated
          router.refresh();
        }
        return Promise.resolve();
      }}
    />
  );
}
